import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { asyncForEach, validateFileName } from '@/utils';
import lodash from 'lodash';
import moment from 'moment-timezone';

export interface Message {
    id: string;
    status: string;
    client_id: string;
    client_info: any;
    seller_id: string;
    store: string;
    order_id: string;
    order_info: any;
    conversation: any;
}

export interface MessageState {
    activeMessage: Message | null;
    activeMessageLoading: boolean;
    pendingMessages: Array<any>;
    pendingMessagesLoading: boolean;
    recordMessages: Array<any>;
    invoiceMessages: Array<any>;

    recordMessagesLoading: boolean;
    invoiceMessagesLoading: boolean;

    responseTime: Array<any>;

    messagesPerPage: number;
    messagesPage: number;
    messagesTotal: number;
}

const state: MessageState = {
    activeMessage: {
        id: '',
        status: '',
        client_id: '',
        client_info: [],
        seller_id: '',
        store: '',
        order_id: '',
        order_info: [],
        conversation: [],
    },
    activeMessageLoading: false,

    pendingMessages: [],
    invoiceMessages: [],

    pendingMessagesLoading: false,
    recordMessages: [],
    recordMessagesLoading: false,
    invoiceMessagesLoading: false,


    responseTime: [],

    messagesPerPage: 1,
    messagesPage: 1,
    messagesTotal: 1,
};

const mutations = {
    TOGGLE_RECORDMESSAGES_LOADING(state: MessageState, data: boolean) {
        state.recordMessagesLoading = data;
    },
    SET_RECORDMESSAGES(state: MessageState, data: PaginatedCollection) {
        state.recordMessages = data.items;
        state.messagesPerPage = data.perPage;
        state.messagesPage = data.currentPage;
        state.messagesTotal = data.totalItems;
    },
    SET_INVOICEMESSAGES(state: MessageState, data: PaginatedCollection) {
        state.invoiceMessages = data.items;
        state.messagesPerPage = data.perPage;
        state.messagesPage = data.currentPage;
        state.messagesTotal = data.totalItems;
    },
    TOGGLE_INVOICEMESSAGES_LOADING(state: MessageState, data: boolean) {
        state.invoiceMessagesLoading = data;
    },
    SET_PUSHRECORDS(state: MessageState, data: PaginatedCollection) {
        state.recordMessages.forEach(element => {
            data.items.push(element);
        });
        let recordMessages = lodash.uniqBy(data.items, 'id');
        recordMessages = lodash.orderBy(recordMessages, ['date_created'], ['desc']);
        state.recordMessages = recordMessages;
        state.messagesTotal = data.totalItems;
    },
    SET_PUSHPENDING(state: MessageState, data: PaginatedCollection) {
        state.pendingMessages.forEach(element => {
            data.items.push(element);
        });
        let pendingMessages = lodash.uniqBy(data.items, 'id');
        pendingMessages = lodash.orderBy(pendingMessages, ['date_created'], ['asc']);
        state.pendingMessages = pendingMessages;
        state.messagesTotal = data.totalItems;
        state.responseTime = data.times;
    },
    TOGGLE_PENDINGMESSAGES_LOADING(state: MessageState, data: boolean) {
        state.pendingMessagesLoading = data;
    },
    SET_PENDINGMESSAGES(state: MessageState, data: PaginatedCollection) {
        state.pendingMessages = data.items;
        state.messagesPerPage = data.perPage;
        state.messagesPage = data.currentPage;
        state.messagesTotal = data.totalItems;
    },
    TOGGLE_ACTIVE_MESSAGE_LOADING(state: MessageState, data: boolean) {
        state.activeMessageLoading = data;
    },
    SET_ACTIVE_MESSAGE(state: MessageState, data: Message) {
        state.activeMessage = data;
    },
};

const actions = {
    //search by orderId
    async getOneOrder({ _, commit }: any, { search, page }: any | null) {
        commit('TOGGLE_RECORDMESSAGES_LOADING', true);

        let params = '';
        if (search) {
            params += `&filter[order_id][_eq]=${search}`;
        }
        params += `&meta=total_count&meta=filter_count`;
        if (page) params += `&offset=${(page - 1)}`;
        let endpoint = `items/messages?${params}`;

        await directusApi('GET', endpoint)
            .then(async res => {
                let message = res.data.data;

                await asyncForEach(message, async (m: any) => {
                    console.log(m);
                    await asyncForEach(m.conversation, async (c: any) => {
                        console.log(c);
                    });

                });

                commit('SET_RECORDMESSAGES', {
                    items: message,
                    totalItems: res.data.meta.filter_count,
                });
            })

            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_RECORDMESSAGES_LOADING', false);
            });
    },

    // async pushRecords({ _, commit }: any, { record }: any | null) {
    //     commit('TOGGLE_RECORDMESSAGES_LOADING', true);
    //     let params = '';
    //     params += `&filter[status][_neq]=blocked&sort=-date_created&meta=total_count&meta=filter_count`;
    //     params += `&limit=3&offset=${record - 3}`;
    //     let endpoint = `items/messages?${params}`;
    //     // console.log(endpoint);
    //     let records = [];
    //     await directusApi('GET', endpoint)
    //         .then(async res => {
    //             let message = res.data.data;
    //             await asyncForEach(message, async (q: any) => {
    //                 let recordsQ = [];
    //                 // console.log(q);
    //                 records.push(q);
    //             });
    //             commit('SET_PUSHRECORDS', {
    //                 items: records,
    //                 totalItems: res.data.meta.filter_count,
    //             });
    //         }).catch(err => {
    //             console.log(err);
    //         }).finally(() => {
    //             commit('TOGGLE_RECORDMESSAGES_LOADING', false);
    //         });
    // },

    //historial
    async getAll({ _, commit }: any, { page, search, sortName, sortValue, filterLogisticType, filterStatus, message_status_filter,
        shipment_status_filter, claim_return_status_filter, day_filter, assigned_move_filter, start_date,
        end_date, }: any) {

        commit('TOGGLE_RECORDMESSAGES_LOADING', true);

        let limit = 5;
        let params = '';
        params += `&sort=-date_created&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=${limit}&offset=${(page - 1) * limit}`;
        let endpoint = `items/messages?${params}`;

        await directusApi('GET', endpoint)
            .then(res => {
                console.log(res.data.data);

                commit('SET_RECORDMESSAGES', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_RECORDMESSAGES_LOADING', false);
            });
    },

    // ************************************************************************************
    // codigo optimizado
    async getAllPending({ _, commit, dispatch }: any, { offset, page }: any | null) {
        try {
            commit('TOGGLE_PENDINGMESSAGES_LOADING', true);
            const limit = 5;
            const endpoint = 'custom/legacy-mercadolibre/pendingMessages';
            const res2 = await directusApi('GET', endpoint);

            const items = [];
            let itemsMessages2 = [];
            let messagesInvoice2 = [];

            if (res2.data.length > 0) {
                for (const el of res2.data) {  //array original
                    const messagesOrder = lodash.orderBy(el.conversation, ['message_date.created'], ['desc']);; //Conversation messages ordered from oldest to newest
                    messagesOrder.shift(); //Delete the first message from the original array
                    const messageWithConversation = { ...el, conversation_0: messagesOrder }; //Show the normal message and add the conversation_0 field which is where the message that was deleted in position 0 of the original array will go
                    items.push(messageWithConversation);
                    itemsMessages2 = lodash.orderBy(items, ['last_message_date']); //Sort the total of items from newest to old to newest by field last_messaje_date
                
                }
            }
            dispatch("processMessage", { messages: itemsMessages2 });

            const totalItems = itemsMessages2.length;
            const start = (page - 1) * limit;
            const end = start + limit;
            const paginatedItems = itemsMessages2.slice(start, end);
            console.log(paginatedItems);

            commit('SET_PENDINGMESSAGES', {
                items: paginatedItems,
                perPage: limit,
                currentPage: page,
                totalItems,
            });
        } catch (error) {
            console.error(`Error processing pending messages: ${error.message}`);
        } finally {
            commit('TOGGLE_PENDINGMESSAGES_LOADING', false);
        }
    },

    async getAllInvoice({ _, commit, dispatch }: any, { messages, page }: any | null) {
        try {
            commit('TOGGLE_INVOICEMESSAGES_LOADING', true);
            const limit = 5;
            const endpoint = 'custom/legacy-mercadolibre/pendingMessages';
            const res2 = await directusApi('GET', endpoint);

            const items = [];
            let itemsMessages2 = [];

            if (res2.data.length > 0) {
                for (const el of res2.data) {  //array original
                    const messagesInvoice = el.conversation.filter(message => message.text.toLowerCase().includes('factura') && message.from.user_id !== 430774329);
                    const newObject = { ...el, conversation_invoice: messagesInvoice };

                    const messagesOrder = lodash.orderBy(newObject.conversation, ['message_date.created'], ['desc']);; //Conversation messages ordered from oldest to newest
                    messagesOrder.shift(); //Delete the first message from the original array
                    const messageWithConversation = { ...newObject, conversation_0: messagesOrder }; //Show the normal message and add the conversation_0 field which is where the message that was deleted in position 0 of the original array will go
                    if(messageWithConversation.conversation_invoice.length > 0) {
                        items.push(messageWithConversation);
                        itemsMessages2 = lodash.orderBy(items, ['last_message_date']); //Sort the total of items from newest to old to newest by field last_messaje_date
                    }
                }
            }

            const totalItems = itemsMessages2.length;
            const start = (page - 1) * limit;
            const end = start + limit;
            const paginatedItems = itemsMessages2.slice(start, end);

            commit('SET_INVOICEMESSAGES', {
                items: paginatedItems,
                perPage: limit,
                currentPage: page,
                totalItems,
            });
        } catch (error) {
            console.error(`Error processing pending messages: ${error.message}`);
        } finally {
            commit('TOGGLE_INVOICEMESSAGES_LOADING', false);
        }
    },

    async updateMessagePriority({ _, commit, dispatch }: any, { messageId }: any | null) {
        try {
            await directusApi('PATCH', `items/messages/${messageId}`, { priority: true });
            console.log(`Message with ID ${messageId} updated successfully.`);
        } catch (error) {
            console.error(`Error updating message with ID ${messageId}: ${error.message}`);
            throw error;
        }
    },

    async processMessage({ _, commit, dispatch }: any, { messages }: any | null) {
        // mostrar como urgente si es mayor a un dia
        if (messages.length > 0) {
            messages.forEach(item => {
                const lastMessage = item.conversation[item.conversation.length - 1];
                if (lastMessage.from.user_id !== 430774329) {
                    const messageDate = moment.utc(lastMessage.message_date.created).tz('America/Mexico_City');
                    const currentDate = moment().tz('America/Mexico_City');
                    const timeDifference = currentDate.diff(messageDate);

                    if (timeDifference > 86400000 && item.priority === false) {
                        dispatch("updateMessagePriority", { messageId: item.id });
                    }
                }
                return false;
            });
        }

    },

    async getOne({ _, commit }: any, { id }: any) {
        commit('TOGGLE_ACTIVE_MESSAGE_LOADING', true);
        await directusApi('GET', `items/messages/${id}`)
            .then(res => {
                let conversation = res.data.data;
                let orderConversation = lodash.orderBy(conversation.conversation, ['message_date.created'], ['desc']);
                let conver = { ...conversation, conversation: orderConversation };

                commit('SET_ACTIVE_MESSAGE', conver);
            })
            .catch(err => {
                console.log(err);
            }).finally(() => {
                commit('TOGGLE_ACTIVE_MESSAGE_LOADING', false);
            });
    },

    async postMessage({ _, commit, dispatch }: any, { id, message, store, updated_by, client_id, file }: any | null) {
        commit('TOGGLE_PENDINGMESSAGES_LOADING', true);
        // console.log(id, message, store, updated_by, client_id, file);

        let fileNew = [];
        if (file.length > 0) {
            if (file[0].origin == 'upload') {
                await directusApi('POST', `files`, file[0].file)
                    .then(async (resFile: any) => {
                        console.log(resFile);

                        fileNew = [
                            {
                                id: resFile.data.data.id,
                                url: `https://directus.prodelec.app/files/${resFile.data.data.id}`,
                                origin: file[0].origin,
                                file: file[0].file
                            }
                        ];
                        console.log(fileNew);

                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }

        if (store == 'prodelec') {
            await directusApi('POST', `custom/legacy-mercadolibre/prodelec/message`, { id, message, updated_by, file: fileNew }).then(async res => {
                console.log(res);
                dispatch("getAllPending", { offset: 0, page: 1 });
                dispatch("getAllInvoice", { messages: [], page: 1 });
            });
        } else {
            await directusApi('POST', `custom/legacy-mercadolibre/messages`, { id, message, updated_by, client_id, file: fileNew }).then(async res => {
                console.log(res);
                dispatch("getAllPending", { offset: 0, page: 1 });
                dispatch("getAllInvoice", { messages: [], page: 1 });
            });
        }
        // commit('TOGGLE_PENDINGMESSAGES_LOADING', false);
        // return false;
    },

    async downloadFile({ _, commit }: any, { file, store }: any) {
        console.log(file, { store });
        if (store == 'officialStores') {
            console.log();

            window.open('url_file', '_blank');
            return false;
            await directusApi('POST', `custom/legacy-mercadolibre/getFile`, { file: file.filename }).then(async (res: any) => {
                console.log(res);
                console.log(res.data);

                var img = document.createElement('img');
                img.src = 'data:image/jpeg;base64,' + btoa(unescape(encodeURIComponent(res.data)));
                document.body.appendChild(img);


                // var blob = new Blob([res.data], { type: "application/pdf" });
                // var objectUrl = URL.createObjectURL(blob);
                // window.open(objectUrl);


                // window.open(url_file, '_blank');
                return false;

                // var binaryString = window.atob(res.data);
                var binaryString = btoa(unescape(encodeURIComponent(res.data)));
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                // var blob = new Blob([bytes], { type: "image/jpeg" });
                var blob = new Blob([bytes], { type: "application/pdf" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var fileName = 'dev';
                link.download = fileName;
                link.click();
                // window.open(res.data, '_blank');
                // const file = new File([
                //     new Blob([res])
                // ], "output_file_name");
                // console.log({ file });
                // let url = window.URL.createObjectURL(file);
                // window.open(url, '_blank');

                // var a = document.createElement("a"); //Create <a>
                // a.href = "data:image/png;base64," + file; //Image Base64 Goes here
                // a.download = "Image.png"; //File name Here
                // a.click(); //Downloaded file

                // console.log(JSON.stringify(res.data));
                // dispatch("getAllPending", { offset: 0 });
            });
        }
    }

    // async postMessage({ _, commit, dispatch }: any, { id, message, store, updated_by }: any | null) {
    //     if (store == 'prodelec') {
    // await directusApi('POST', `custom/legacy-mercadolibre/prodelec/message`, { id, message, updated_by }).then(async res => {
    //     // console.log(res);
    //     dispatch("getAllPending", { offset: 0 });
    // });
    //     } else {
    //         await directusApi('POST', `custom/legacy-mercadolibre/message`, { id, message, updated_by }).then(async res => {
    //             // console.log(res);
    //             dispatch("getAllPending", { offset: 0 });
    //         });
    //     }
    //     // return false;
    // },

    // async blockUser({ _, commit, dispatch }: any, { id, store, client_id }: any | null) {
    //     if (store == 'prodelec') {
    //         await directusApi('POST', `custom/legacy-mercadolibre/prodelec/blockUser`, { id, client_id }).then(async res => {
    //             dispatch("getAllPending", { offset: 0 });
    //         });
    //     } else {
    //         await directusApi('POST', `custom/legacy-mercadolibre/blockUser`, { id, client_id }).then(async res => {
    //             dispatch("getAllPending", { offset: 0 });
    //         });
    //     }
    // },

    // async deleteMessage({ _, commit, dispatch }: any, { id, store }: any | null) {
    //     if (store == 'prodelec') {
    //         await directusApi('POST', `custom/legacy-mercadolibre/prodelec/deleteMessage`, { id }).then(async res => {
    //             dispatch("getAllPending", { offset: 0 });
    //         });
    //     } else {
    //         await directusApi('POST', `custom/legacy-mercadolibre/deleteMessage`, { id }).then(async res => {
    //             dispatch("getAllPending", { offset: 0 });
    //         });
    //     }
    // }
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
